import React from "react";
import { getSimpleTitle } from "./utils.js";
import "./index.scss";
export default function MainPic(props) {
  var titleData = props.titleData,
    type = props.type,
    imgUrl = props.imgUrl,
    videoUrl = props.videoUrl,
    imgArr = props.imgArr;
  var simpleTitle = getSimpleTitle(titleData === null || titleData === void 0 ? void 0 : titleData.title);
  if (imgUrl && imgUrl.indexOf("cbu01.alicdn.com") !== -1) {
    if (imgUrl.indexOf(".gif") !== -1 && imgUrl.indexOf(".jpg") !== -1) {
      imgUrl = imgUrl.replace(/(.summ|.search|.jpg)/g, "") + "?_=2020";
    } else {
      imgUrl = imgUrl.replace(/(.summ.|.search.)/, ".220x220.") + "?_=2020";
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "zr-main-pic"
  }, type === "img" && imgUrl && /*#__PURE__*/React.createElement("img", {
    className: "main-pic img",
    src: imgUrl,
    alt: simpleTitle
  }), type === "video" && videoUrl && /*#__PURE__*/React.createElement("video", {
    className: "main-pic",
    autoPlay: true,
    controls: true,
    src: videoUrl
  }));
}